export class RouteUri {
  public static readonly AUTH = 'auth';
  public static readonly RESET_PASSWORD = 'reset-password';
  public static readonly DASHBOARD = 'dashboard';
  public static readonly FINANCES = 'finances';
  public static readonly INVOICE_FORM = 'invoice/form';
  public static readonly CREDIT_NOTE_FORM = 'credit-note/form';
  public static readonly DOCUMENTATION = 'documentation';
  public static readonly DIRECTORY = 'directory';
  public static readonly DIRECTORY_FORM = 'directory/form';
  public static readonly DIRECTORY_FORM_COMPANY = 'company';
  public static readonly DIRECTORY_FORM_CONTACT = 'contact';
  public static readonly DIRECTORY_FORM_DETAILS = 'details';
  public static readonly DIRECTORY_FORM_PRODUCTS = 'products';
  public static readonly DIRECTORY_FORM_BILLING = 'customer-billing';
  public static readonly DIRECTORY_FORM_LICENCE_SERVERS = 'licence-servers';
  public static readonly DIRECTORY_COMPANIES = 'companies';
  public static readonly DIRECTORY_CONTACTS = 'contacts';
  public static readonly TIMESHEETS = 'timesheets';
  public static readonly TIMESHEETS_LIST = 'list';
  public static readonly CALL_STATISTICS = 'calls';
  public static readonly TODOS = 'todos';
  public static readonly DOCUMENTS = 'documents';
  public static readonly SETTINGS = 'settings';

  public static CREDIT_NOTES = 'credit-notes';
  public static INVOICES = 'invoices';
  public static DIRECT_DEBIT = 'direct-debit';
  public static ACCOUNTING_EXPORT = 'export';
  public static PEPPOL = 'peppol';
  public static readonly PRODUCTS = 'products';
  public static readonly PRODUCTS_LIST = 'list';
  public static readonly LICENCE_PLANS = 'licence-plans';
  public static readonly FEATURES = 'features';
  public static readonly PLUGINS = 'plugins';
  public static readonly ACCOUNTING_CODES = 'accounting-accounts';
  public static readonly ACCOUNTING_SETTINGS = 'accounting';
  public static readonly TODO_SETTINGS = 'todo';
  public static readonly TIMESHEET_SETTINGS = 'timesheet';
  public static readonly ACCOUNTING_PERIODS = 'accounting-periods';
  public static readonly ACCOUNTING_TAXES = 'accounting-taxes';
  public static readonly MAIL_TEMPLATE_SETTINGS = 'mail-templates';
  public static readonly PERMISSIONS_SETTINGS = 'permissions';
  public static readonly USER_SETTINGS = 'users';
}
